module.exports = __webpack_public_path__ + "img/wendu.8a560a6e.png";